import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { Dropdown } from '../../../../components/Dropdown';

import { Loader } from '../../../../components/Loader';
import { deleteTransportOrderTransporter, initiateNewTransportOrderValue, setNewTransportOrderValue } from '../../actions';
import { selectNewTransportOrder, selectNewTransportOrderValue, selectTransportOrder } from '../../selectors';
import DatePicker from 'react-datepicker';

import { Calendar, CircleTimes, EditSquare } from '../../../../components/Icon';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { VehicleCreateFieldCompany } from '../../../Vehicles/pages/create/FieldCompany';
import {
  REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE,
  TRANSPORT_ORDER_STATUS_OPTIONS,
  TRANSPORT_ORDER_TYPE,
} from '../../constants';
import { selectWork, selectWorks } from '../../../Api/selectors';
import cn from 'classnames';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './Field.module.css';

import { VehicleSelectionModalButton } from '../../../Vehicles/components/VehicleSelectionModalButton';
import AddressView from '../../../Address/components/AddressView';
import LoadingField from '../../../../containers/App/Components/LoadingField/LoadingField';
import { REQUEST_TRANSPORTERS } from '../../../Transporters/constants';
import { selectTransporters } from '../../../Transporters/selectors';
import { HBox, VBox } from '../../../../components/Box';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { selectVehicleBulkActionsList } from '../../../Vehicles/selectors';
import { Cell, List, Row } from '../../../../components/List';

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {
  status: TRANSPORT_ORDER_STATUS_OPTIONS,
  type: TRANSPORT_ORDER_TYPE,
};

const REQUIRED_FIEDLS = ['addressFromId', 'addressToId'];

const Container = styled.div`
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 14px;
  color: red;
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class TransportOrderCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }
  get transportersOptions() {
    const options = this.props.transporters
      ?.slice() // clone array to avoid mutating original
      .sort((a, b) => {
        const nameA = `${a?.name ?? ''} ${a?.surname ?? ''}`.toLowerCase();
        const nameB = `${b?.name ?? ''} ${b?.surname ?? ''}`.toLowerCase();
        return nameA.localeCompare(nameB);
      })
      .map(t => {
        return {
          value: t?.id,
          label: `${t?.name ?? ''} ${t?.surname ?? ''}`,
        };
      });

    return options;
  }

  isTextariaBlock() {
    return ['remarks'].indexOf(this.props.type) > -1;
  }

  isDate() {
    return ['scheduledDate', 'datePlanned', 'dateToPlan'].indexOf(this.props.type) > -1;
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS || this.props.type === 'transporterId';
  }

  get allowManualCompanyFrom() {
    return this.props.vehicleId;
  }
  get allowManualCompanyTo() {
    return this.props.vehicleId;
  }
  get allowManualAddressFrom() {
    return this.props.vehicleId;
  }
  get allowManualAddressTo() {
    return this.props.vehicleId;
  }
  get allowManualVehicle() {
    return !this.props.vehicleId && !this.props.addVehicleModal;
  }

  get isRequiredMark() {
    let required = false;

    if (['transporterId', 'datePlanned'].includes(this.props.type) && !this.props.value) {
      required = true;
    }
    if (this.props.type === 'addressFromId' && !this.props.values?.addressFromId && !this.props.values?.addressFromManual) {
      required = true;
    }
    if (this.props.type === 'addressToId' && !this.props.values?.addressToId && !this.props.values?.addressToManual) {
      required = true;
    }

    return required;
  }

  wrap(children) {
    const containsCheckbox = element => {
      if (React.isValidElement(element) && element.props) {
        return typeof element.props.className === 'string' && element.props.className.includes('checkbox');
      }
      return false;
    };

    const isCheckboxComp = React.Children.toArray(children).some(child => containsCheckbox(child));

    if (isCheckboxComp) {
      return <div>{children}</div>;
    } else {
      return (
        <div>
          <label className="form-label">
            {this.formFieldLabel()}

            {this.isRequiredMark && <RequireMark>*</RequireMark>}
          </label>
          {children}
        </div>
      );
    }
  }

  formFieldLabel() {
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    let options = vals?.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));

    if (this.props.type === 'transporterId') {
      options = this.transportersOptions;
    }

    const value = options.find(o => o.value == this.props.value) || {};

    if (this.props.type === 'transporterId' && this.props.workTransporters) {
      return <LoadingField />;
    }

    return (
      <div className={styles.container}>
        <SearchSelect
          className={styles.dropdown}
          disabled={this.props.type === 'status' && !this.props.values?.id}
          options={options}
          value={value}
          onChange={pair => this.props.setValue(pair.value)}
        />
        {this.props.isEdit && this.props.type === 'transporterId' && (
          <ButtonComponent
            style={'ButtonSoftDelete'}
            onClick={() => {
              this.props.deleteTransporter(result => {
                if (!result.transporterId) {
                  this.props.setValue('', this.props.type);
                }
              });
            }}
          >
            <CircleTimes />
          </ButtonComponent>
        )}
      </div>
    );
  }

  datePicker() {
    let format = this.props.value?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.props.value && this.props.value !== 'null' && dayjs(this.props.value, format);
    return (
      <>
        <div className={cn('d-flex align-items-stretch', styles.containerDatePicker)} style={{ gap: '8px' }}>
          {/* DatePicker */}
          <DatePicker
            className={styles.datePicker}
            dateFormat="dd-MM-yyyy"
            selected={selected && selected !== 'Invalid Date' && selected.toDate()}
            onChange={date => {
              let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
              d && this.props.setValue(d);
            }}
          />

          {/* Today Button */}
          <ButtonComponent
            style={'ButtonSoftPrimaryFullWidth'}
            onClick={() => {
              const today = dayjs().format('YYYY-MM-DD hh:mm:ss');
              this.props.setValue(today);
            }}
          >
            {this.lbl(`vehicle.property.today`)}
          </ButtonComponent>

          {/* Tomorrow Button */}
          <ButtonComponent
            style={'ButtonSoftPrimaryFullWidth'}
            onClick={() => {
              const tomorrow = dayjs()
                .add(1, 'day')
                .format('YYYY-MM-DD hh:mm:ss');
              this.props.setValue(tomorrow);
            }}
          >
            {this.lbl(`vehicle.property.tomorrow`)}
          </ButtonComponent>
        </div>

        {/* Calendar Icon */}
      </>
    );
  }

  detailsField() {
    return (
      <div>
        <textarea
          value={this.props.value}
          onChange={evt => this.props.setValue(evt.target.value)}
          className="form-control"
        />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  isImportDisabled() {
    return !!this.props?.vehicle?.incoming_invoice;
  }

  renderField() {
    if (this.props.value === undefined) return null;
    let disabled = false;
    const type = this.props.type;
    if (this.props.type === 'import') disabled = this.isImportDisabled();

    if (this.isTextariaBlock()) {
      return this.detailsField();
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isDate()) {
      return this.datePicker();
    }

    switch (this.props.type) {
      case 'vehicleId':
        const vehicle = this.props.values?.vehicleObj;
        const label = `${vehicle?.regplate ?? ''} ${vehicle?.brand_name ?? ''} ${vehicle?.model_name ??
          ''} ${vehicle?.model_info ?? ''}`;

        if (this.props.bulkActionsList?.length) {
          return (
            <div>
              <div className={styles.scrollContainer}>
                <List>
                  {this.props.bulkActionsList?.map(v => {
                    return (
                      <Row key={`${v?.id}_${v?.id}`}>
                        <Cell>
                          <VBox>
                            <HBox style={{ textWrap: 'nowrap' }}>{v.brand_name}</HBox>
                            {v?.id ?? '-'}
                          </VBox>
                        </Cell>
                      </Row>
                    );
                  })}
                </List>
              </div>
            </div>
          );
        }
        return (
          <div className={styles.buttonsLabel}>
            {this.props.values.initVehicleManual ? (
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.values?.vehicleManual}
                onChange={e => this.props.setValue(e.target?.value, 'vehicleManual')}
              />
            ) : (
              <input className="form-control" disabled key={this.props.type} value={label} />
            )}
            <VehicleSelectionModalButton
              onSelect={vehicle => {
                this.props.setValue(vehicle, 'vehicleObj');
                this.props.setValue(vehicle?.id, 'vehicleId');
              }}
            />
            {this.allowManualVehicle && (
              <div className={styles.button}>
                <ButtonComponent
                  size={'btn-sm'}
                  style={this.props.values?.initVehicleManual ? 'ButtonSoftDelete' : 'ButtonSoftEdit'}
                  onClick={() => {
                    if (this.props.values?.initVehicleManual) {
                      this.props.setValue(false, 'initVehicleManual');
                      this.props.setValue('', 'vehicleManual');

                      return;
                    }
                    this.props.setValue(true, 'initVehicleManual');
                  }}
                >
                  {this.props.values?.initVehicleManual ? 'X' : <EditSquare />}
                </ButtonComponent>
              </div>
            )}
          </div>
        );

      case 'companyFromId':
        return (
          <HBox vCenter>
            {this.props.values.initCompanyFromManual ? (
              <input
                placeholder="company from"
                className="form-control"
                key={this.props.type}
                value={this.props.values.companyFromManual}
                onChange={evt => this.props.setValue(evt.target.value, 'companyFromManual')}
              />
            ) : (
              <VehicleCreateFieldCompany
                formField
                selectCompanyObj
                title={this.props.type}
                key={this.props.type}
                type={this.props.type}
                selectedCompanyId={this.props.values?.companyFromId}
                onChange={selectedCompany => {
                  this.props.setValue(selectedCompany, 'companyFrom');
                  this.props.setValue(selectedCompany?.id, 'companyFromId');
                }}
              />
            )}

            {/* {this.allowManualCompanyFrom && (
              <div className={styles.button}>
                <ButtonComponent
                  size={'btn-sm'}
                  style={this.props.values?.initCompanyFromManual ? 'ButtonSoftDelete' : 'ButtonSoftEdit'}
                  onClick={() => {
                    if (this.props.values?.initCompanyFromManual) {
                      this.props.setValue(false, 'initCompanyFromManual');
                      this.props.setValue('', 'companyFromManual');

                      return;
                    }
                    this.props.setValue(true, 'initCompanyFromManual');
                  }}
                >
                  {this.props.values?.initCompanyFromManual ? 'X' : <EditSquare />}
                </ButtonComponent>
              </div>
            )} */}
          </HBox>
        );
        break;
      case 'addressFromId':
        return (
          <HBox vCenter>
            <HBox flip>
              {this.props.values.initAddressFromManual ? (
                <textarea
                  placeholder="address from"
                  className="form-control"
                  key={this.props.type}
                  value={this.props.values.addressFromManual}
                  onChange={evt => this.props.setValue(evt.target.value, 'addressFromManual')}
                />
              ) : (
                this.props.values.companyFrom?.addresses?.map(address => {
                  return (
                    <AddressView
                      key={address?.id}
                      lbl={this.lbl}
                      address={address}
                      selectAddress={selectedAddress => {
                        this.props.setValue(selectedAddress?.id, 'addressFromId');
                      }}
                      selected={this.props.values?.addressFromId === address?.id}
                      company_name={this.props.values?.companyFrom?.name}
                    />
                  );
                })
              )}
            </HBox>
            {/* {this.allowManualAddressFrom && (
              <div className={styles.button}>
                <ButtonComponent
                  size={'btn-sm'}
                  style={this.props.values?.initAddressFromManual ? 'ButtonSoftDelete' : 'ButtonSoftEdit'}
                  onClick={() => {
                    if (this.props.values?.initAddressFromManual) {
                      this.props.setValue(false, 'initAddressFromManual');
                      this.props.setValue('', 'addressFromManual');
                      return;
                    }
                    this.props.setValue(true, 'initAddressFromManual');
                  }}
                >
                  {this.props.values?.initAddressFromManual ? 'X' : <EditSquare />}
                </ButtonComponent>
              </div>
            )} */}
          </HBox>
        );
        break;

      case 'companyToId':
        return (
          <HBox vCenter>
            {this.props.values.initCompanyToManual ? (
              <input
                placeholder="company to"
                className="form-control"
                key={this.props.type}
                value={this.props.values.companyToManual}
                onChange={evt => this.props.setValue(evt.target.value, 'companyToManual')}
              />
            ) : (
              <VehicleCreateFieldCompany
                formField
                selectCompanyObj
                title={this.props.type}
                key={this.props.type}
                type={this.props.type}
                selectedCompanyId={this.props.values?.companyToId}
                onChange={selectedCompany => {
                  this.props.setValue(selectedCompany, 'companyTo');
                  this.props.setValue(selectedCompany?.id, 'companyToId');
                }}
              />
            )}

            {/* {this.allowManualCompanyTo && (
              <div className={styles.button}>
                <ButtonComponent
                  size={'btn-sm'}
                  style={this.props.values?.initCompanyToManual ? 'ButtonSoftDelete' : 'ButtonSoftEdit'}
                  onClick={() => {
                    if (this.props.values?.initCompanyToManual) {
                      this.props.setValue(false, 'initCompanyToManual');
                      this.props.setValue('', 'companyToManual');
                      return;
                    }
                    this.props.setValue(true, 'initCompanyToManual');
                  }}
                >
                  {this.props.values?.initCompanyToManual ? 'X' : <EditSquare />}
                </ButtonComponent>
              </div>
            )} */}
          </HBox>
        );

      case 'addressToId':
        return (
          <HBox vCenter>
            <HBox flip>
              {this.props.values.initAddressToManual ? (
                <textarea
                  placeholder="address to"
                  className="form-control"
                  key={this.props.type}
                  value={this.props.values.addressToManual}
                  onChange={evt => this.props.setValue(evt.target.value, 'addressToManual')}
                />
              ) : (
                this.props.values.companyTo?.addresses?.map(address => {
                  return (
                    <AddressView
                      key={address?.id}
                      lbl={this.lbl}
                      address={address}
                      selectAddress={selectedAddress => {
                        this.props.setValue(selectedAddress?.id, 'addressToId');
                      }}
                      selected={this.props.values?.addressToId === address?.id}
                      company_name={this.props.values?.companyTo?.name}
                    />
                  );
                })
              )}
            </HBox>
            {/* {this.allowManualAddressTo && (
              <div className={styles.button}>
                <ButtonComponent
                  size={'btn-sm'}
                  style={this.props.values?.initAddressToManual ? 'ButtonSoftDelete' : 'ButtonSoftEdit'}
                  onClick={() => {
                    if (this.props.values?.initAddressToManual) {
                      this.props.setValue(false, 'initAddressToManual');
                      this.props.setValue('', 'addressToManual');
                      return;
                    }
                    this.props.setValue(true, 'initAddressToManual');
                  }}
                >
                  {this.props.values?.initAddressToManual ? 'X' : <EditSquare />}
                </ButtonComponent>
              </div>
            )} */}
          </HBox>
        );
        break;
    }
  }
}

TransportOrderCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE),
    workTransporters: selectWorks([REQUEST_TRANSPORTERS]),
    transporters: selectTransporters(),

    value: selectNewTransportOrderValue(ownProps.type),
    values: selectNewTransportOrder(),
    transportOrder: selectTransportOrder(ownProps.transportOrderId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewTransportOrderValue(name, value));
    },

    initiateValue() {
      dispatch(initiateNewTransportOrderValue(ownProps.type));
    },
    deleteTransporter(callback) {
      dispatch(deleteTransportOrderTransporter(ownProps.transportOrderId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderCreateField = compose(withConnect, withRouter)(TransportOrderCreateFieldComp);
